import RagnaDataTable from '../ReactComponents/RagnaDataTable';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useRef,useState } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { ajax_api, getAccess } from '../../Globals';
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { Helmet } from 'react-helmet';

const ActivityCategories = props => {
    const API_URL = `${ajax_api}users/get-activities-table`;
    const SET_API_URL = `${ajax_api}users/set-activity`;
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const [refreshTable] = useOutletContext();

    const ActNameInputRef = useRef(null);
    const [draw, setDraw] = useState(-9999);

    const onSubmit = (d, url) => {
        var f = new FormData();
        Object.keys(d).forEach(dd => f.append(dd, Array.isArray(d[dd]) ? d[dd][0] : d[dd]));

        axios.post(url, f, {withCredentials:true}).then(_ => {
            setModalOpen(false);
            setDraw(r => r + 1);
            alert("Successfully edited activity")
        }).catch(alert)
    }
    const [modalOpen, setModalOpen] = useState(false);


    const modal = <RagnaModal
        noBtn={true}
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
        width={500}
        title="Edit Role Activity Name"
        body={<>
            <form onSubmit={
                handleSubmit(d =>
                    onSubmit(d, `${ajax_api}users/set-activity`, true))}>
                <input type="hidden" {...register("Id", { required: "This field is required" })} />
                Activity Name:
                <input type="text" className="form-control" {...register("Name")} />
                <ErrorMessage errors={errors} name="Name"
                    render={({ message }) => <p className="text-danger m-0">{message}</p>} />
                <button className="ro-button mt-2">
                    <span>Save</span>
                </button>
            </form>
        </>
        } />

    //datatable options
    const table_columns = [
        { display: "ID", col: "Id" }, 
        { display: "Activity", col: "Name" },
        //{
        //    display: "Category", col: "ActivityCategory", customValue: e => e.Name ?? "[No Category]", dontOrder: true
        //}
    ];
    const search_columns = [
        { display: "Activity", col: "FullName" }, 
    ];


    return <>
        <Helmet>
            <title>LTS | Role Permissions Management</title>
        </Helmet>
        {
            modal
        }
        <RagnaDataTable
            draw={draw}
            refreshTable={refreshTable}
            customEntrySizes={[10, 50, 100, 1000]}
            title="Role Activities Datatable"
            columns={table_columns}
            s_columns={search_columns}
            defaultOrder={true}
            maxPagination={8}
            generalSearch={true}
            defaultOrderCol="ID"
            url={API_URL}
            actions={[
                //{
                //    action: "url", display: "Edit",
                //    content: d => `${VIEW_URL}/${d.ID}`,
                //},
                {
                    hideIf: !getAccess(90),
                    component: d => <button className="ro-button" onClick={_ => {
                        reset(d.data);
                        setModalOpen(true);
                    } }>
                        <span>Edit</span>
                    </button>
                }
            ]}
        />
    </>;
}

export default ActivityCategories;